import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-8">
      <Card className="max-w-md w-full p-8 text-center">
        <XCircle className="h-12 w-12 mx-auto text-zinc-400" />
        <div className="mt-4 text-2xl font-semibold font-display">Payment cancelled</div>
        <div className="text-sm text-muted-foreground mt-1">No charges were made.</div>
        <Button onClick={() => nav("/resident/pay")} className="mt-6 rounded-full">Return to payments</Button>
      </Card>
    </div>
  );
}
